'use strict';

import jQuery from 'jquery';
import fbq from './../../vendor/facebook-pixel';

/**
 * Landing
 *
 * JavaScript functions for the the Landing page
 */
var Landing = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // If this is the landing page then perform a lead track back to Facebook
      if (privateNS.$container.length > 0) {
        fbq('track', 'Lead');
      }
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Landing